import {styled} from '@mui/material/styles';
import {FC} from 'react';
import {DropzoneState} from 'react-dropzone';
import {Typography} from '../../Typography';
import {useFileInputContext} from '../FileInputContext';
import {excludeComponentProps} from '../../utils/excludeComponentProps';

type FileInputOverlayProps = Pick<DropzoneState, 'isDragActive' | 'isDragAccept' | 'isDragReject'>;

const StyledDiv = styled('div', {
    ...excludeComponentProps('isDragActive', 'isDragAccept', 'isDragReject')
})<Partial<FileInputOverlayProps>>(({
    theme, isDragActive
}) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    visibility: 'hidden',
    opacity: 0,
    zIndex: 10,
    borderRadius: theme.tokens.FuelBorderRadiusMd,
    backgroundColor: theme.tokens.FuelColorGreen50,
    border: `solid 2px ${theme.tokens.FuelColorGreen400}`,

    ...isDragActive && {
        visibility: 'visible',
        opacity: 1
    }
}));

export const FileInputOverlay: FC<unknown> = () => {
    /** NOTE: you can also access isDragAccept and isDragRejected */
    const {
        isDragActive, textMap
    } = useFileInputContext();

    return (
        <StyledDiv
            className='FileInputDragOverlay-root'
            isDragActive={isDragActive}
        >
            <Typography
                className='FileInputDragOverlay-text'
                size='2xl'
            >
                {textMap.actionDrop}
            </Typography>
        </StyledDiv>
    );
};

FileInputOverlay.displayName = 'FileInputOverlay';
